"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBackgroundStyles = exports.Banner = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _svgFetcher = _interopRequireDefault(require("../../utils/svgFetcher"));
var _Sanitizer = require("../../base-components/Sanitizer/Sanitizer");
var _Image = require("../../base-components/Image/Image");
var _Icon = require("../../base-components/Icon/Icon");
var _BulletListItem = require("../../base-components/BulletListItem/BulletListItem");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var getBackgroundStyles = exports.getBackgroundStyles = function getBackgroundStyles(_ref) {
  var color = _ref.color,
    pattern = _ref.pattern,
    img = _ref.img;
  var inlineStyles = {};
  if (color) {
    inlineStyles.backgroundColor = color;
    return inlineStyles;
  }
  if (img) {
    inlineStyles.backgroundSize = 'cover';
    inlineStyles.backgroundRepeat = 'no-repeat';
    inlineStyles.backgroundImage = "url(".concat(img, ")");
    return inlineStyles;
  }
  if (pattern) {
    inlineStyles.backgroundRepeat = 'repeat';
    inlineStyles.backgroundImage = "url(".concat(pattern, ")");
    inlineStyles.width = '100%';
    return inlineStyles;
  }
  return inlineStyles;
};
var Banner = exports.Banner = function Banner(_ref2) {
  var primaryHeadline = _ref2.primaryHeadline,
    secondaryHeadline = _ref2.secondaryHeadline,
    title = _ref2.title,
    titleComponent = _ref2.titleComponent,
    primaryHeadlineComponent = _ref2.primaryHeadlineComponent,
    secondaryHeadlineComponent = _ref2.secondaryHeadlineComponent,
    children = _ref2.children,
    button = _ref2.button,
    img = _ref2.img,
    background = _ref2.background,
    styles = _ref2.styles,
    closeBanner = _ref2.closeBanner,
    className = _ref2.className,
    images = _ref2.images,
    imgOnLoad = _ref2.imgOnLoad,
    CloseSvg = _ref2.CloseSvg,
    items = _ref2.items,
    qeId = _ref2.qeId;
  if (_typeof(background) !== 'object' || Object.keys(background).length > 1) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "empty"
    });
  }
  var inlineStyles = getBackgroundStyles(background);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(className, styles.heroBannerContainer),
    style: inlineStyles,
    "data-qe-id": qeId
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.heroBannerOverlay
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.toasterBannerContent
  }, closeBanner && /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.exitButton
  }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    onClick: closeBanner,
    Svg: CloseSvg
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.heroBannerContent
  }, img && img.src && /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.imageContainer
  }, /*#__PURE__*/_react["default"].createElement(_Image.Image, {
    className: styles.img,
    src: img.src,
    alt: img.alt,
    onLoad: imgOnLoad
  })), images.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(styles.images, 'imageContainer')
  }, images.map(function (props) {
    return /*#__PURE__*/_react["default"].createElement(_Image.Image, _extends({
      className: styles.img
    }, props));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.contentContainer,
    "data-qe-id": qeId ? "".concat(qeId, "__content") : undefined
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.headlines
  }, title && /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.title
  }, /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
    safelySetInnerHTML: title,
    className: styles.titleTag,
    Component: titleComponent
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.primaryHeadline
  }, /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
    safelySetInnerHTML: primaryHeadline,
    Component: primaryHeadlineComponent
  })), secondaryHeadline && /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.secondaryHeadline
  }, /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
    safelySetInnerHTML: secondaryHeadline,
    Component: secondaryHeadlineComponent
  }))), items && /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.bulletListItems
  }, items.map(function (itemProps, i) {
    var key = itemProps.key || "benefit-item-".concat(i);
    return /*#__PURE__*/_react["default"].createElement(_BulletListItem.BulletListItem, _extends({}, itemProps, {
      key: key
    }));
  })), children, button && /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.buttonContainer
  }, button))))));
};
Banner.propTypes = {
  className: _propTypes["default"].string,
  styles: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func])).isRequired,
  title: _propTypes["default"].string,
  primaryHeadline: _propTypes["default"].string,
  secondaryHeadline: _propTypes["default"].string,
  titleComponent: _propTypes["default"].node,
  primaryHeadlineComponent: _propTypes["default"].node,
  secondaryHeadlineComponent: _propTypes["default"].node,
  children: _propTypes["default"].node,
  img: _propTypes["default"].objectOf(_propTypes["default"].any),
  background: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  button: _propTypes["default"].element,
  closeBanner: _propTypes["default"].func,
  items: _propTypes["default"].arrayOf(_propTypes["default"].object),
  images: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    src: _propTypes["default"].string.isRequired,
    alt: _propTypes["default"].string.isRequired
  })),
  imgOnLoad: _propTypes["default"].func,
  CloseSvg: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
  qeId: _propTypes["default"].string
};
Banner.defaultProps = {
  className: '',
  styles: {},
  background: {},
  title: '',
  primaryHeadline: '',
  secondaryHeadline: '',
  titleComponent: 'span',
  primaryHeadlineComponent: 'span',
  secondaryHeadlineComponent: 'span',
  children: undefined,
  img: {},
  items: undefined,
  button: undefined,
  closeBanner: undefined,
  images: [],
  imgOnLoad: undefined,
  CloseSvg: (0, _svgFetcher["default"])('axp-glyph-close', 'us-consumer'),
  qeId: undefined
};